import {
  Box,
  Text,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs as TabsChakra,
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import { FormikProvider, useFormik } from 'formik'
import { SummaryCacheTab } from './SummaryCacheTab'
import { WordCloudCacheTab } from './WordCloudCacheTab'
import { CompareSummaryCacheTab } from './CompareSummaryCacheTab'

/**
 * Cache Management Panel Component
 * Contains tabs for Summary and WordCloud cache management
 */
export const CacheManagementPanel: FC = () => {
  const [activeTab, setActiveTab] = useState(0)

  const formik = useFormik({
    initialValues: {},
    onSubmit: () => {},
  })

  return (
    <FormikProvider value={formik}>
      <Box
        bgColor="white.50"
        borderRadius={4}
        mb="16px"
        padding="24px"
        w="100%"
      >
        <Text
          fontSize="24px"
          fontWeight="700"
          letterSpacing="tighter"
          lineHeight="40px"
          mb="16px"
        >
          キャッシュ管理
        </Text>

        <TabsChakra
          index={activeTab}
          variant="unstyled"
          onChange={setActiveTab}
        >
          <TabList borderBottom="1px solid #E8ECEF" padding="0 24px">
            <Tab
              _selected={{
                bg: '#E8ECEF',
                color: '#141718',
                fontWeight: 600,
                borderTopRightRadius: '4px',
              }}
              borderBottom={'none'}
              borderTopLeftRadius={4}
              color={'#0084FF'}
              fontSize={'sm'}
              fontWeight={'normal'}
              h="48px"
              px="24px"
            >
              Summary Cache
            </Tab>
            <Tab
              _selected={{
                bg: '#E8ECEF',
                color: '#141718',
                fontWeight: 600,
                borderTopRightRadius: '4px',
              }}
              borderBottom={'none'}
              borderTopLeftRadius={4}
              color={'#0084FF'}
              fontSize={'sm'}
              fontWeight={'normal'}
              h="48px"
              px="24px"
            >
              WordCloud Cache
            </Tab>
            <Tab
              _selected={{
                bg: '#E8ECEF',
                color: '#141718',
                fontWeight: 600,
                borderTopRightRadius: '4px',
              }}
              borderBottom={'none'}
              borderTopLeftRadius={4}
              color={'#0084FF'}
              fontSize={'sm'}
              fontWeight={'normal'}
              h="48px"
              px="24px"
            >
              Compare Summary Cache
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel p={0} pt="24px">
              <SummaryCacheTab />
            </TabPanel>
            <TabPanel p={0} pt="24px">
              <WordCloudCacheTab />
            </TabPanel>
            <TabPanel p={0} pt="24px">
              <CompareSummaryCacheTab />
            </TabPanel>
          </TabPanels>
        </TabsChakra>
      </Box>
    </FormikProvider>
  )
}
